// export const MAIN_URL = 'http://192.168.1.14:8000' // change it to the main deployed url

// export const MAIN_URL = 'https://backend-dot-konav2-dev.wl.r.appspot.com' //development URL

export const MAIN_URL = process.env.REACT_APP_SERVER // Staging URL
export const SOCKET_MAIN_URL = process.env.REACT_APP_SOCKET_SERVER
export const STRIPE_KEY = process.env.REACT_APP_STRIPE_KEY
